const ButtonForModal = ({
  children,
  buttonValue = children ? "" : "button",
  type = "submit",
  onClick,
  className,
  isDisabled,
}) => {
  return (
    <button
      type={type}
      value={buttonValue}
      onClick={onClick}
      disabled={isDisabled}
      className={
        (isDisabled ? "bg-gray-900" : "") +
        `hover:scale-90  shadow-md h-6  gap-1 lg:h-6 py-1 px-3 whitespace-pre border text-white  hover:text-white flex flex-row items-center justify-center text-xs3 border rounded-full mx-1  transition duration-500 ease select-none focus:outline-none focus:shadow-outline undefined ${className}`

        //  `hover:scale-90 flex flex-row shadow-md text-white h-6 lg:h-6 lg:w-20 lg:px-1 w-20 hover:bg-hquaternary hover:border-hquaternary items-center justify- gap-1 text-xs3 border rounded-full  py-1 transition duration-500 ease select-none focus:outline-none focus:shadow-outline  ${className}`
      }
    >
      {buttonValue}
      {children}
    </button>
  );
};

export default ButtonForModal;
